import { render } from "./dzjyDetail.vue?vue&type=template&id=495f8750&scoped=true&ts=true"
import script from "./dzjyDetail.vue?vue&type=script&lang=ts"
export * from "./dzjyDetail.vue?vue&type=script&lang=ts"

import "./dzjyDetail.vue?vue&type=style&index=0&id=495f8750&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495f8750"]])

export default __exports__